/** Wanderlog export — per-day plain-text place list; share sheet on touch,
 * clipboard on desktop (no file downloads: iPad-safe). */
import { isFixed } from "@trip/shared/types";
import { store } from "../store.js";
import { banner } from "./banner.js";

export function exportWanderlog() {
  const def = store.def;
  const lines: string[] = [];
  for (const d of def.days) {
    const acts = d.items
      .map((it, i) => (!isFixed(it) ? store.slots[`${d.id}_${i}`] : null))
      .filter((v) => v && v.dur !== 0)
      .map((v) => ({ a: def.act[v!.act], st: v!.st }))
      .filter((x) => x.a && !x.a.nomodal);
    if (!acts.length) continue;
    lines.push(d.dow + " " + d.date + " — " + d.loc + ":");
    for (const x of acts) {
      const parts = (x.a.cat || "").split("·");
      const city = parts.length > 1 ? parts[parts.length - 1].trim() : "";
      lines.push(
        "• " + x.a.name.split("—")[0].trim() + (city ? " — " + city : "") + (x.st === 2 ? "  [BOOKED]" : x.st === 1 ? "  [confirmed]" : "")
      );
    }
    lines.push("");
  }
  const txt =
    `${def.name} — selected activities (rev ${store.rev})\n\n` +
    lines.join("\n").trim() +
    "\n\nPaste these into Wanderlog's add-places box (it matches names to map pins). Flights/hotels/ferries are already in the Wanderlog trip.";

  const isTouch = "ontouchend" in document;
  if (isTouch && navigator.canShare) {
    try {
      const f = new File([txt], "wanderlog-places.txt", { type: "text/plain" });
      if (navigator.canShare({ files: [f] })) {
        navigator.share({ files: [f], title: "Wanderlog place list" }).catch(() => {});
        return;
      }
    } catch {
      /* fall through */
    }
  }
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(txt).then(
      () => banner("✓ Place list copied — in Wanderlog, open your trip and paste into the add-places box.", "ok"),
      () => showCopyModal(txt)
    );
  } else showCopyModal(txt);
}

/** Fallback when the clipboard API is unavailable: selectable text in the modal. */
function showCopyModal(txt: string) {
  const m = document.getElementById("modal")!;
  m.style.maxWidth = "";
  m.innerHTML = `
    <div class="m-head"><div class="m-cat">Wanderlog export</div><h3>Copy your place list</h3>
      <button class="m-close" data-action="close" aria-label="close">✕</button></div>
    <div class="m-body">
      <textarea readonly style="width:100%; height:300px; font:12px/1.5 ui-monospace,monospace; border:1px solid var(--line); border-radius:8px; padding:10px" onclick="this.select()">${txt.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</textarea>
      <div style="margin-top:8px; font-size:12.5px; color:var(--mut)">Tap the box to select everything, then copy — and paste into Wanderlog's add-places box.</div>
    </div>`;
  document.getElementById("modalbg")!.classList.add("open");
}
